<template>
  <div class="container" style="background: #f8f8f8">
    <!-- 顶部大图展示 -->
    <div id="banner" ref="banner">
      <div class="header-title">
        <div class="title1">未来·共赢</div>
        <p class="title2">
          未知远大于已知，未来空间无限
        </p>
        <div class="title3">
          积土成山，积水成渊。生态聚合，共生无界; 最大程度地为合作伙伴提供内容变现能力
        </div>
        <div class="tab-pane">
          <ul>
            <li @click="changeSwiperType(0)" :class="swiperTypeIndex==0 ? 'borderBottom' : ''">影视剧</li>
            <li @click="changeSwiperType(1)" :class="swiperTypeIndex==1 ? 'borderBottom' : ''">电竞</li>
            <li @click="changeSwiperType(2)" :class="swiperTypeIndex==2 ? 'borderBottom' : ''">少儿</li>
            <li @click="changeSwiperType(3)" :class="swiperTypeIndex==3 ? 'borderBottom' : ''">舞蹈</li>
            <li @click="changeSwiperType(4)" :class="swiperTypeIndex==4 ? 'borderBottom' : ''">汽车</li>
          </ul>
        </div>
      </div>
      <!-- 走马灯 -->
       <div class="slideshow" id="slideshow">
        <div class="baseContent">
          <div class="leftArrow prev">
            <img :src="arrowLeft" @click="arrowClick('prev')">
          </div>
          <div class="carousel">
            <el-carousel type="card" height="370px" arrow="never" :autoplay="false" @change="handChange" indicator-position="none" ref="cardShow">
              <el-carousel-item v-for="(item, index) in imgArr" :key="index">
                <div class="card-inbox" :style="item.backgroundStyle">
                  <div class="box">
                    <div class="content">
                      <p class="contentItem1" v-html="item.describe1"></p>
                      <p class="contentItem" v-html="item.describe"></p>
                    </div>
                    <div
                      class="applicationForm"
                      :id="item.src"
                      v-if="item.id <= 2"
                    >
                    <el-button round class="topButton redBtn" @click="handleApplication">申请合作</el-button>
                      
                    </div>
                    <div class="applicationForm1" v-else>
                      <el-button round class="topButton disableBtn">敬请期待</el-button>
                    </div>
                  </div> 
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="rightArrow next">
            <img :src="arrowRight" @click="arrowClick('next')"/>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <!-- 我们在大屏端端优势 -->
      <div class="step step2">
        <div style="width:80%;margin:0 auto;">
        <div class="step-title">
          <p class="topTitle">————————
            <span>我们在大屏端的优势</span>————————</p>
          <p class="topTitleDes">
            <span>OUR ADVANTAGE ON THE BIG SCREEN</span></p>
        </div>
        <el-row class="step2row">
          <el-col v-for="item in step2" :span="6" :key="item.key">
            <dl>
              <dt>
                <img
                  :src="item.src"
                  :class="item.key === 1 ? 'transitionDiv' : ''"
                />
              </dt>
              <dd class="title" v-html="item.describe"></dd>
            </dl>
          </el-col>
        </el-row>
        </div>
      </div>
      <!-- 生态赋能 -->
      <div class="step step6">
        <div class="step6-content">
          <el-row class="step6row row-bg" type="flex" justify="space-around">
            <el-col class="step6col-des" :span="8">
              <div class="step6col-des-content">
                <span  class="step6col-des1"> 生态·赋能 </span>
                <h4 class="step6col-des2">
                  ECOLOGICAL EMPOWERMENT</h4>
                <div class="step6col-des3"></div>
                <p class="step6col-des4">
                多种业务生态，赋能内容创作，提升传播效果，扩大影响力、加速与用户的连接、加快变现</p>
              </div>
            </el-col>
          <el-col
            class="step6col"
            v-for="item in step6"
            :span="5" 
            :key="item.key"
          >
            <dl>
              <dt>
                <img
                  :src="item.src"
                  :class="item.key === 1 ? 'transitionDiv' : ''"
                />
              </dt>
              <dd class="title" v-html="item.describe"></dd>
              <dd class="title1" v-html="item.describe1"></dd>
            </dl>
          </el-col>
        </el-row>
        </div>

      </div>
      <!-- 业务合作流程 -->
      <div class="step step3">
        <div class="content">
          <div class="step-title">
          <p class="topTitle"><span>业务合作流程</span></p>
          <p class="topTitleDes">
            <span>BUSINESS COLLABORATION PROCESS</span></p>
        </div>
        <el-row>
          <template v-for="item in step3">
            <el-col :span="2" :key="item.key" :offset="item.key==1?3:0">
              <template>
                <dl>
                  <dt><img :class="item.margintop30 ? 'margin-top30' : ''" :src="item.src" /></dt>
                <dd class="title">{{ item.describe }}</dd>
              </dl>
              </template>
            </el-col>
          </template>
        </el-row>
        </div>
      </div>
      <div class="step step5">
        <div class="step-title" v-if="needLogin || flag">
          <p class="topTitle">————————
            <span>欢迎入驻</span>————————</p>
          <p class="topTitleDes">
            <span>MOVE IN</span></p>
        </div>
        <div class="btn-box">
          <el-button round class="topButton" @click="handleApplication"  v-if="needLogin || flag"
            >即刻申请</el-button
          >
        </div>
      </div>
      <!-- 底部链接加版权信息 -->
      <div class="footer">
        <div class="footer-content">
          <img class="logo" :src="logo" alt="" />
          <div style="text-align: center">
            <p class="breadcrumb">
              <span class="spanWord" @click="sy">网站首页</span>
              <span>|</span>
              <span class="spanWord" @click="handleUs">关于我们</span>
              <span>|</span>
              <span class="spanWord" @click="handleUser">用户协议</span>
              <span>|</span>
              <span class="spanWord" @click="handlePrivacy">隐私协议</span>
              <span>|</span>
              <span class="spanWord" @click="handleContact">联系我们</span>
            </p>
            <div class="rightCopy">
              <p>广播电视节目制作经营许可证：（津）字第379号</p>
              <p>网络文化经营许可证：津网文[2016]1209-018号</p>
              <p>津ICP备12004891号</p>
            </div>
          </div>
          <img class="cord" :src="cord" alt="" />
        </div>
      </div>
    </div>
    <div
      @click="goTop"
      style="
        position: fixed;
        right: 0;
        bottom: 50%;
        width: 38px;
        height: 38px;
        background: #a5a7b5;
        text-align: center;
        line-height: 44px;
        border-radius: 50%;
        z-index:5;
      "
    >
      <img src="../../assets/home-image/top.png" alt="" />
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo.png'
import cord from '@/assets/home-image/cord.png'
import { getUserInfoNew2 } from '../../resource/api/index'
export default {
  name: 'home',
  data () {
    return {
      swiperTypeIndex:0,
      needLogin: false,
      login_url: '',
      flag: false, // 是否登录
      logo: logo,
      cord: cord,
      selected: 0, // 当前展示的图片
      imgWidth: 803, // 图片宽度
      flag1: true, // 节流阀，防止连续点击切换
      // currentId: 1,
      num: document.documentElement.clientHeight || document.body.clientHeight, // 浏览器可视高度
      arrowLeft: require('../../assets/home-image/arrow-left.png'),
      arrowRight:require('../../assets/home-image/arrow-right.png'),
      imgArr: [
        {
          id: 1,
          describe: 'Film and TV series',
          describe1: '影视剧',
          backgroundStyle:{
            backgroundImage: 'url(' + require('../../assets/home-image/swiper1.jpg') + ')'
          }
        },
        {
          id: 2,
          describe: 'E-sports',
          describe1: '电竞',
          backgroundStyle:{
            backgroundImage: 'url(' + require('../../assets/home-image/swiper2.jpg') + ')'
          }
        },
        {
          id: 3,
          describe: 'Kids',
          describe1: '少儿',
          backgroundStyle:{
            backgroundImage: 'url(' + require('../../assets/home-image/swiper3.jpg') + ')'
          }
        },
        {
          id: 4,
          describe: 'Dance',
          describe1: '舞蹈',
          backgroundStyle:{
            backgroundImage: 'url(' + require('../../assets/home-image/swiper4.jpg') + ')'
          }
        },
        {
          id: 5,
          describe: 'Automobile',
          describe1: '汽车',
          backgroundStyle:{
            backgroundImage: 'url(' + require('../../assets/home-image/swiper5.jpg') + ')'
          }
        }
      ],
      step2: [
        {
          key: 1,
          src: require('../../assets/home-image/step21.png'),
          describe: '国内<span style="color: #DF3F30 !important;">2000+万</span>日活的大屏端渠道',
        },
        {
          key: 2,
          src: require('../../assets/home-image/step22.png'),
          describe: '全面覆盖国内外主流电视品牌厂商'
        },
        {
          key: 3,
          src: require('../../assets/home-image/step23.png'),
          describe: '海外业务覆盖欧美、东南亚等'
        },
        {
          key: 4,
          src: require('../../assets/home-image/step24.png'),
          describe: '新视听、炫舞未来等明星产品'
        }
      ],
      step3: [
        {
          key: 1,
          src: require('../../assets/home-image/step31.png'),
          describe: '注册账号'
        },
        {
          key: 2,
          margintop30:true,
          src: require('../../assets/home-image/step36.png')
        },
        {
          key: 3,
          src: require('../../assets/home-image/step32.png'),
          describe: '填写资质'
        },
        {
          key: 4,
          margintop30:true,
          src: require('../../assets/home-image/step36.png')
        },
        {
          key: 5,
          src: require('../../assets/home-image/step33.png'),
          describe: '资质审核'
        },
        {
          key: 6,
          margintop30:true,
          src: require('../../assets/home-image/step36.png')
        },
        {
          key: 7,
          src: require('../../assets/home-image/step34.png'),
          describe: '上传作品'
        },
        {
          key: 8,
          margintop30:true,
          src: require('../../assets/home-image/step36.png')
        },
        {
          key: 9,
          src: require('../../assets/home-image/step35.png'),
          describe: '获取收益'
        },
      ],
      step4: [
        {
          key: 1,
          src: require('../../assets/home-image/touxiang.png')
        },
        {
          key: 2,
          src: require('../../assets/home-image/touxiang.png')
        },
        {
          key: 3,
          src: require('../../assets/home-image/touxiang.png')
        },
        {
          key: 4,
          src: require('../../assets/home-image/touxiang.png')
        },
        {
          key: 5,
          src: require('../../assets/home-image/touxiang.png')
        },
        {
          key: 6,
          src: require('../../assets/home-image/touxiang.png')
        },
        {
          key: 7,
          src: require('../../assets/home-image/touxiang.png')
        },
        {
          key: 8,
          src: require('../../assets/home-image/touxiang.png')
        },
        {
          key: 9,
          src: require('../../assets/home-image/touxiang.png')
        },
        {
          key: 10,
          src: require('../../assets/home-image/touxiang.png')
        }
      ],
      step6: [
        {
          key: 1,
          src: require('../../assets/home-image/stfn1.png'),
          describe: '创新生态',
          describe1: '内容创新，打造明星产品，为产业赋能'
        },
        {
          key: 2,
          src: require('../../assets/home-image/stfn2.png'),
          describe: '渠道生态',
          describe1: '打通面向渠道用户的整条产业链'
        },
        {
          key: 3,
          src: require('../../assets/home-image/stfn3.png'),
          describe: '海外生态',
          describe1: '用海外布局，助力中国“文化走出去”'
        }
      ],
      swiperTop: 0
    }
  },
  created () {
    this.isLogin()
  },
  mounted () {},
  methods: {
    changeSwiperType(index) {
       this.swiperTypeIndex = index
       this.$refs.cardShow.setActiveItem(index)
    },
    sy () {
      this.$router.replace('/')
    },
    handleUs () {
      this.$router.replace('/aboutUs')
    },
    handleUser () {
      this.$router.replace('/useragreement')
    },
    handlePrivacy () {
      this.$router.replace('/privacyPolicy')
    },
    handleContact () {
      this.$router.replace('/contactUs')
    },
    // 回到顶部
    goTop () {
      scrollTo(0, 0)
    },
    // 获取用户信息
    async isLogin () {
      try {
        const { redirect_url, errorCode } = await getUserInfoNew2()
        this.login_url = redirect_url
        if (errorCode == 0) {
          this.flag = true
        } else if (errorCode == 401) {
          this.needLogin = true
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 立即申请
    handleApplication () {
      // 判断是否登录
      if (this.flag) {
        // 判断是否为测试环境地址
        if (window.location.href.includes('stage-')) {
          window.location.href = 'https://stage-umedia.cloud.ottcn.com/'
        } else {
          window.location.href = 'https://umedia.cloud.ottcn.com/'
        }
      } else if (this.needLogin) {
        // 判断是否为测试环境地址
        if (window.location.href.includes('stage-')) {
          window.location.href = 'https://stage-open.cloud.ottcn.com/common/register/2'
        } else {
          window.location.href = 'https://open.cloud.ottcn.com/common/register/2'
        }
      }
    },
    arrowClick(val) {
      if(val === 'next') {
        this.$refs.cardShow.next()
      } else {
        this.$refs.cardShow.prev()
      }
    },
    handChange (index) {
      this.swiperTypeIndex = index
    }
  }
}
</script>

<style scoped lang="less">
@import "index";
.el-col-lg-4-8 {
  width: 20%;
}
</style>
